export default __webpack_public_path__ + "static/media/building-trust.36411fc5.png";